import { useContext, useEffect } from 'react'
import { HtmlIframeProps } from 'semantic-ui-react'
import { useVimeoVideoDetails } from './vimeoVideoDetails/useVimeoVideoDetails'
import { UserReducerActions } from '../Context/User/UserReducer'
import { UserContext } from '../Context/User/UserContext'
import { checkIfUserSubscriptionTypeIsEnough } from '../helpers/utils'
import { checkIfArrayHasSameElements } from '../helpers/array/MyArray'
import { NotificationType } from '../Context/GlobalNotification/Types'
import { FRAUD_WARNING, LOGOUT_WARNING } from '../const/consts'
import { CookieService } from '../service/CookieStorageService'
import { GlobalNotificationContext } from '../Context/GlobalNotification/GlobalNotificationProvider'
import { GlobalLoaderContext } from '../Context/GlobalLoader/GlobalLoader'
import { SubscriptionTypes } from '../service/Product/ProductService'

interface VimeoIDS {
  sub: SubscriptionTypes
  vimeoId: string
  productId: string
}

function extractVimeoVideoIDFromIframeSrc(iframe: HtmlIframeProps): string {
  return iframe.attributes.src.value.substring(
    iframe.attributes.src.value.indexOf('.vimeo.com/video/') + 17,
    iframe.attributes.src.value.indexOf('?')
  )
}

function isClientBoughtProduct(
  boughtProductIds: string[],
  productsIds: string[]
) {
  return checkIfArrayHasSameElements(boughtProductIds, productsIds)
}

export const useVimeoHackingRadar = () => {
  const userContext: UserReducerActions = useContext(UserContext)
  const showNotification = useContext(GlobalNotificationContext)
  const showLoader = useContext(GlobalLoaderContext)
  const { vimeoVideoDetails } = useVimeoVideoDetails()
  const violationFoundHandler = (videoVimeoItem: VimeoIDS): void => {
    if (
      !checkIfUserSubscriptionTypeIsEnough(
        userContext.userDetails,
        videoVimeoItem.sub
      ) &&
      !isClientBoughtProduct(userContext.userDetails.boughtProducts, [
        videoVimeoItem.productId
      ])
    ) {
      showNotification(NotificationType.ERROR, FRAUD_WARNING)
      CookieService.removeItem()
      showLoader(true, LOGOUT_WARNING)
      setTimeout((): void => {
        window.location.replace(window.location.origin)
      }, 6000)
    }
  }

  useEffect((): (() => void) => {
    const interval = setInterval(() => {
      const allIFramesOnThePage: HtmlIframeProps[] = Array.from(
        document.querySelectorAll('iframe')
      )
      if (allIFramesOnThePage.length > 0) {
        allIFramesOnThePage.forEach((iframe: HtmlIframeProps): void => {
          const isIframeVimeoVideo = iframe.attributes?.src?.value?.includes(
            'player.vimeo.com/video/'
          )
          if (isIframeVimeoVideo) {
            const vimeoID = extractVimeoVideoIDFromIframeSrc(iframe)
            const matchingVideos = vimeoVideoDetails.filter(
              (video) => video.vimeoId === vimeoID
            )
            if (matchingVideos.length > 0) {
              const videoVimeo = matchingVideos[0]

              violationFoundHandler(videoVimeo)
            }
          }
        })
      }
    }, 15000)
    return (): void => clearInterval(interval)
  }, [vimeoVideoDetails.length])
}
